import Button from '../Buttons/Button'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const PaymentSuccessCard = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <div
      className={`text-center shadow-md sm:fixed z-50 bg-white max-w-[90%] sm:max-w-[580px] w-full px-5 sm:px-11  py-6 sm:py-9 rounded-20px`}
    >
      <h2 className='font-bold text-2xl'>{t('paymentSuccessTitle')}</h2>
      <p className='font-base text-black my-4'>{t('paymentSuccessText')}</p>

      <div className='mt-9 flex flex-row justify-center'>
        <Button
          type='submit'
          text={t('loginToYourAccount')}
          onClickHandler={() => {
            navigate('/login')
          }}
        />
      </div>
    </div>
  )
}

export default PaymentSuccessCard
